import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { patchRouteActive } from '../../../../actions';

const RouteActiveButton = ({
  dispatchActiveRoute,
  routeId,
  active,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickActive = () => dispatchActiveRoute({ routeId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickActive}
        onClickCancel={closeModal}
      />
      <Button color={active ? 'danger': 'success'} onClick={openModal} disabled={disabled}>
        <i className={active ? "fa fa-ban" : "fa fa-check-circle-o"}/>{active ? ' Desactivar' : ' Activar'} 
      </Button>
    </>
  );
};

RouteActiveButton.propTypes = {
  dispatchActiveRoute: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  active: PropTypes.bool.isRequired,
  routeId: PropTypes.number.isRequired,
};

RouteActiveButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchActiveRoute: patchRouteActive,
};

export default connect(null, mapDispatchToProps)(RouteActiveButton);
